import PropTypes from 'prop-types'
import React from 'react'
import { Notification } from 'react-notification'
import { connect } from 'react-redux'
import { getProfileUpdateError } from '../../../selectors'
import { setProfileUpdateError } from '../../../actions'

export class FormNotification extends React.PureComponent {
  hideNotification = () => {
    if (this.props.hideNotification) {
      this.props.hideNotification()
    } else {
      this.props.setProfileUpdateError('')
    }
  }

  render () {
    const {message, isActive} = this.props
    return (
      <Notification
        isActive={isActive}
        message={message || ''}
        action={'Sakrij'}
        onClick={this.hideNotification}
      />
    )
  }
}

const mapStateToProps = (state, ownProps) => {
  const error = getProfileUpdateError(state)
  return {
    message: ownProps.message || error,
    isActive: ownProps.message ? ownProps.isActive : Boolean(error)
  }
}

FormNotification.propTypes = {
  message: PropTypes.string,
  setProfileUpdateError: PropTypes.func.isRequired,
  hideNotification: PropTypes.func,
  isActive: PropTypes.bool.isRequired
}

export default connect(mapStateToProps, {setProfileUpdateError})(FormNotification)
